<script setup lang="ts">
import { defineProps, defineEmits } from "vue";
import { ICzinCoinState } from "@/types/calculators";
import ResultStack from "@/views/Calculators/ICzinPrediction/components/ResultStack.vue";
import GradientButton from "@/components/buttons/GradientButton.vue";
import { useI18n } from "vue-i18n";

defineProps<{
  coins: ICzinCoinState[];
  results: number[];
  isFlipping: boolean;
  isLoading: boolean;
}>();

defineEmits(["flip"]);

const { t } = useI18n();

function getCoinStyle(coin: ICzinCoinState) {
  return {
    transform: `rotateY(${coin.angle}deg)`,
    transition: "transform 0.8s cubic-bezier(.23,1.09,.7,1.06)",
  };
}
</script>

<template>
  <div class="w-full flex flex-col items-center">
    <!-- COINS -->
    <div class="flex justify-center gap-5 md:gap-[36px] mb-4 md:mb-6">
      <div
        v-for="(coin, idx) in coins"
        :key="idx"
        class="relative size-[90px] md:size-40 [perspective:350px] [transform-style:preserve-3d] [transition:transform_0.8s_cubic-bezier(0.23,1.09,0.7,1.06)]"
        :style="getCoinStyle(coin)"
      >
        <!-- Орёл -->
        <div
          class="absolute top-0 left-0 w-full h-full flex items-center justify-center rounded-full shadow-[0_2px_12px_rgba(120,122,168,0.07)] [backface-visibility:hidden] [transform:rotateY(0deg)]"
        >
          <img
            src="@/assets/calculators/iczin/eagle.png"
            alt="Орёл"
            class="size-[90px] md:size-40 select-none pointer-events-none"
          />
        </div>

        <!-- Решка -->
        <div
          class="absolute top-0 left-0 w-full h-full flex items-center justify-center rounded-full shadow-[0_2px_12px_rgba(120,122,168,0.07)] [backface-visibility:hidden] [transform:rotateY(180deg)]"
        >
          <img
            src="@/assets/calculators/iczin/tails.png"
            alt="Решка"
            class="size-[90px] md:size-40 select-none pointer-events-none"
          />
        </div>
      </div>
    </div>

    <ResultStack :results="results" class="mb-4" />

    <GradientButton
      class="w-[263px] min-h-14 mb-4"
      bg-color="bg-brown-gradient"
      hover-bg-color="bg-orange-gradient"
      :text="t('calculators.iczin.throw-coins-btn')"
      :disabled="isFlipping || results.length >= 6"
      @click="$emit('flip')"
      :is-loading="isLoading"
    />

    <h2 class="text-xl font-bold mb-10 text-center text-brown">
      {{ t("calculators.iczin.need-to-throw", { count: 6 - results.length }) }}
    </h2>
  </div>
</template>
